var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.imgShow),expression:"imgShow"}],staticClass:"loading_box"},[_c('div',{staticClass:"loading_mask",on:{"click":_vm.onImgMiss}}),_vm._v(" "),_c('div',{staticClass:"loading_toast",on:{"click":_vm.onImgMiss}},[_c('img',{attrs:{"src":_vm.imgUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }